import { logicalOperator } from './logicalOperator.js';

/**
 * Adds a search term to an existing filter expression.
 * 
 * If the filter already contains terms, it inserts a logical
 * operator (always "and") before adding the new term. (For "or", we add it manually.)
 * 
 * @param {Array} filter - The existing filter array.
 * @param {Array} term - The search term to add.
 * @param {string} [combineWith] - How to combine the term ("and" or "or").
 * @returns {Array} The updated filter array.
 */
export function addTermToFilter(filter, term, combineWith = logicalOperator.AND) {
    if (!filter || !term || (Array.isArray(term) && term.length == 0)) {
        return filter;
    }
    
    if (filter.length > 0) {
        filter.push(combineWith);
    }
    filter.push(term);

    return filter;
}

/**
 * Adds a sorting term to an existing sort array.
 * 
 * @param {Array} sort - The existing sort array.
 * @param {Array} term - The sorting term to add.
 * @returns {Array} The updated sort array.
 */

export function addTermToSort(sort, term) {
    if (!sort || !term) {
        return sort;
    }
    
    sort.push(term);

    return sort;
}